; (function (inovestor) {
    // Create plugin namespace with any desired config variable
    inovestor.ms.chart = inovestor.ms.chart || {};
})(inovestor);


; (function (inovestor, undefined) {
    // Create plugin namespace with any desired config variable
    inovestor.ms.chart.historical = {
        config: {
            apiStocksRelativeUrl: 'chartDatas/historicalData?symbols={symbols}',
            apiFundsRelativeUrl: 'mutualfunds/historicaldata?symbols={symbols}',
            apiIntraDayUrl: 'chartDatas/historicalData?symbols={symbols}&dataType=Intraday',
            apiQuoteUrl: 'quotes?symbols={symbols}'
        }
    };

})(inovestor);


; (function ($, Highcharts, historical, undefined) {

    historical.charts = historical.charts || {};
    historical.charts['fund'] = function () {
        var plugin = this;
        var chart = {
            data: $.extend({}, plugin.options.chartData),

            init: function () { },
            destroy: function () { },

            beforeRender: function () { },
            afterRender: function () { },

            beforeUpdateData: function () { },
            afterUpdateData: function () { },

            updateData: function () {
                var defer = $.Deferred(),
                    symbolsList = plugin._getSymbols();

                if (inovestor.ms.core.isNullOrUndefined(symbolsList))
                    throw 'No Symbols detected';

                // Setup API url with term
                var historicalFundApiUrl = inovestor.ms.core.stringFormat(inovestor.ms.chart.historical.config.apiFundsRelativeUrl, { symbols: symbolsList.join(',') });

                // Call API and render chart
                var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } };
                inovestor.ms.core.ajaxApi(historicalFundApiUrl, options).then(function (data) {
                    if (!inovestor.ms.core.isNullOrUndefined(data)) {
                        // Main series is expecting a symbol property instead of a fundSymbol
                        for (var i in data)
                            data[i].symbol = data[i].fundSymbol;

                        chart._updateStockSeriesData(data);
                        plugin._setFundChartExtremes(false);
                        plugin._chartInstance.redraw();
                        defer.resolve();
                    }
                });

                return defer.promise();
            },
            convertChartDataToChartDataSet: function (chartData) {
                var showBalance = !inovestor.ms.core.isNullOrUndefined(plugin.options.startingBalance);

                if (inovestor.ms.core.isNullOrUndefined(chartData) || inovestor.ms.core.isNullOrUndefined(chartData.historicalDatas))
                    return [];

                var convertedData = [];
                if (chartData.requestStatus === 'success') {
                    for (var j in chartData.historicalDatas) {
                        var historicalData = chartData.historicalDatas[j];

                        if (showBalance) {
                            var percentageChange = 0;
                            var yVal = plugin.options.startingBalance;
                            if (convertedData.length > 0) {
                                var lastPoint = convertedData[convertedData.length - 1];
                                percentageChange = ((lastPoint.navps - historicalData.navps) / lastPoint.navps) * -1;
                                yVal = lastPoint.y + (lastPoint.y * percentageChange);
                            }
                            convertedData.push({
                                y: yVal,
                                x: moment.utc(historicalData.date).valueOf(),
                                formattedY: Highcharts.numberFormat(yVal, 0),
                                navps: historicalData.navps,
                                percentageChange: Highcharts.numberFormat(percentageChange * 100, 2)
                            });
                        }
                        else {
                            var percentageChange = 0;
                            if (convertedData.length > 0) {
                                var lastPoint = convertedData[convertedData.length - 1];
                                percentageChange = ((lastPoint.navps - historicalData.navps) / lastPoint.navps) * -1;
                            }
                            convertedData.push({
                                y: historicalData.navps,
                                x: moment.utc(historicalData.date).valueOf(),
                                formattedY: Highcharts.numberFormat(historicalData.navps * 100, 2),
                                navps: historicalData.navps,
                                percentageChange: Highcharts.numberFormat(percentageChange * 100, 2)
                            });
                        }
                    }
                }
                return convertedData;
            },

            getChartConfig: function () {
                var resource = inovestor.ms.core.getCurrentResource(inovestor.ms.chart.historical.resources);
                var showTitle = !inovestor.ms.core.isNullOrUndefined(plugin.options.showTitle);
                var showBalance = !inovestor.ms.core.isNullOrUndefined(plugin.options.startingBalance)

                return {
                    chart: {
                        zoomType: !plugin.options.isMobile ? 'x' : '',
                        height: plugin.options.isMobile ? 250 : undefined,
                        panning: false,
                        pinchType: false,
                        styledMode: plugin.options.styledMode ? plugin.options.styledMode : false
                    },
                    title: {
                        text: showTitle ? showBalance
                            ? inovestor.ms.core.stringFormat(resource.chartGrowthTitle, { growth: Highcharts.numberFormat(plugin.options.startingBalance, 0) })
                            : resource.chartChangeTitle : null
                    },
                    rangeSelector: {
                        enabled: false
                    },
                    navigator: {
                        enabled: false
                    },
                    scrollbar: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            turboThreshold: 0,
                            states: {
                                hover: {
                                    enabled: false
                                }
                            },
                            animation: false,
                            dataGrouping: {
                                units: [['week', [1]]],
                                dateTimeLabelFormats: {
                                    week: [resource.stockTooltip.week + ' %A, %b %e, %Y', '%A, %b %e', '-%A, %b %e, %Y']
                                },
                            }
                        }
                    },
                    xAxis: {
                        type: 'datetime',
                        ordinal: false,
                        labels: {
                            format: '{value:%b %Y}',
                            rotation: 0
                        }
                    },
                    yAxis: {
                        offset: 35,
                        labels: {
                            style: {
                                fontSize: '10.5px'
                            },
                            formatter: function () {
                                var value = Highcharts.numberFormat(this.value, showBalance? 0 : 2);
                                return value;
                            },
                        },
                        opposite: showBalance? false : true
                    },
                    tooltip: {
                        enabledIndicators: true,
                        headerFormat: '<div><small>{point.key}</small></div>',
                        footerFormat: null,
                        style: {
                            lineHeight: '1.5em'
                        },
                        pointFormatter: function () {
                            var seriesData = plugin._chartTooltipData[this.series.name] ? plugin._chartTooltipData[this.series.name] : null;
                            if (seriesData == null)
                                return null;

                            // If mobile, only show the first series in tooltip
                            if (plugin.options.isMobile && plugin._mainSerieId !== this.series.name)
                                return '';

                            if (this.x == null)
                                return null;
                            var date = new Date(this.x);

                            var dataPoint = null;
                            var date = new Date(this.x);
                            for (var iCnt = 0; iCnt < seriesData.data.length; iCnt++) {
                                var itemDate = new Date(seriesData.data[iCnt].x);

                                //series is always in right order. We take the first to be greater or equal in case of market closed during the week.
                                if (itemDate.getTime() >= date.getTime()) {
                                    dataPoint = seriesData.data[iCnt];
                                    break;
                                }
                            }

                            if (dataPoint == null)
                                return null;

                            var format =
                                '<span style="color:{color};font-weight:bold;">{serieName}</span><br/>';
                            if (showBalance)
                                format += '<span style="font-size:11px;color:#888;font-weight:bold;">' + resource.fundTooltip.balanceLabel + ':  </span>' +
                                    '<span style="font-size:12px;color:{color}">{balance}</span><br/>';

                            format += '<span style="font-size:11px;color:#888;font-weight:bold;">' + resource.fundTooltip.changeLabel + ':  </span>' +
                                '<span style="font-size:12px;color:{color}">{change}</span>';
                            format += '<span style="font-size:11px;color:#888;font-weight:bold;"> ' + resource.fundTooltip.navpsLabel + ':  </span>' +
                                '<span style="font-size:12px;color:{color}">{navps}</span><br/>';

                            var seriesName = !this.change ? seriesData.name : seriesData.name + ' (' + Highcharts.numberFormat(this.change, 2) + '%)';

                            var tooltip = inovestor.ms.core.stringFormat(format, {
                                color: this.color,
                                serieName: seriesName,
                                balance: inovestor.ms.core.stringFormat(resource.fundTooltip.balanceValue, { balance: dataPoint.formattedY }),
                                navps: Highcharts.numberFormat(dataPoint.navps, 2),
                                change: inovestor.ms.core.stringFormat(resource.fundTooltip.changeValue, { change: dataPoint.percentageChange }),
                            });
                            return tooltip;
                        }
                    },
                    series: []
                };
            },
            getChartType: function () {
                return 'line'; // only supports line for now
            },

            _updateStockSeriesData: function (data) {
                // Reset required data
                plugin._chartTooltipData = [];

                var otherSeriesData = [];
                var symbolIndex = 0;
                for (var symbol in plugin._symbols) {
                    for (var index in data) {
                        if (data[index].fundSymbol.toLowerCase() === symbol.toLowerCase()) {
                            if (symbolIndex === 0)
                                plugin._mainSerieDataSource = data[index];
                            else
                                otherSeriesData.push(data[index]);
                        }
                    }
                    symbolIndex++;
                }
                plugin._otherSeriesDataSources = otherSeriesData;
                plugin._updateChartSeries();
            },
        };

        return chart;
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.highcharts, inovestor.ms.chart.historical);


; (function ($, Highcharts, historical, undefined) {

    historical.charts = historical.charts || {};
    historical.charts['stock'] = function () {
        var plugin = this;
        var chart = {
            data: $.extend({}, {
                showVolume: true,
                showNavigator: true,
                isOneDaySelected: false,
                zoomType: 'month',
                zoomCount: 6,
            }, plugin.options.chartData),

            toolbarOptions: $.extend({}, {
                showZoom: true,
                showIndexComparer: true,
                showTypeSwitcher: true,
                showFullScreenButton: true
            }, plugin.options.toolbarOptions),

            init: function () {
                if (plugin.options.isMobile) {
                    chart.data.showVolume = true;
                    chart.data.showNavigator = true;
                }

                // Add default others symbols
                if (inovestor.ms.core.isNullOrUndefined(plugin.options.otherSymbols))
                    plugin.options.otherSymbols = [
                        { symbol: 'INXTSX:SPTSX', nameEn: 'S&P TSX', nameFr: 'S&P TSX', selected: false },
                        { symbol: 'INXTSX:SPTSXVEN', nameEn: 'S&P TSX Venture', nameFr: 'S&P TSX Venture', selected: false },
                        { symbol: 'INXSNP:SPX', nameEn: 'S&P 500', nameFr: 'S&P 500', selected: false },
                        { symbol: 'INXDJX:DJI', nameEn: 'Dow Jones', nameFr: 'Dow Jones', selected: false },
                        { symbol: 'INXNDX:CCMP', nameEn: 'NASDAQ', nameFr: 'NASDAQ', selected: false }
                    ];

                // make sure options are correctly set when loading as intra day by default
                if (chart.data.isOneDaySelected || chart.data.zoomType === 'intraday') {
                    chart.data.isOneDaySelected = true;
                    chart.data.zoomType = 'intraday';
                }
            },
            destroy: function () {
                if (chart.data.$actionBarElement)
                    chart.data.$actionBarElement.remove();
            },

            beforeRender: function () {
            },
            afterRender: function () {
                var resource = inovestor.ms.core.getCurrentResource(inovestor.ms.chart.historical.resources);
                var $actionBar = $('<div class="historical-chart-actions"></div>');

                // Add Stock chart specific stuff
                if (chart.toolbarOptions.showZoom) {
                    chart.data.$actionBarElement = chart.data.$actionBarElement || $actionBar;
                    chart._addTimespanSelectors(); // Timespan selectors supprots mobile as is
                }
                if (chart.toolbarOptions.showIndexComparer) {
                    chart.data.$actionBarElement = chart.data.$actionBarElement || $actionBar;
                    chart._addIndexSelectors();
                }
                if (chart.toolbarOptions.showTypeSwitcher) {
                    chart.data.$actionBarElement = chart.data.$actionBarElement || $actionBar;
                    chart._addChartTypeDropdown();
                }
                if (chart.toolbarOptions.showFullScreenButton) {
                    chart.data.$actionBarElement = chart.data.$actionBarElement || $actionBar;
                    chart._addFullScreenButton();
                }

                if (chart.data.$actionBarElement) {
                    plugin.$chartElement.addClass('has-chart-actions');
                    plugin.$element.prepend(chart.data.$actionBarElement);
                }
            },

            beforeUpdateData: function () {
                if (chart.data.$actionBarElement) 
                    chart.data.$actionBarElement.css('visibility', 'hidden');
            },
            afterUpdateData: function () {
                if (chart.data.$actionBarElement)
                    chart.data.$actionBarElement.css('visibility', 'visible');      
            },

            updateData: function () {
                var defer = $.Deferred(),
                    symbolsList = plugin._getSymbols(),
                    type = chart.data.zoomType,
                    count = chart.data.zoomCount,
                    isChangingMode = (chart.data.isOneDaySelected && type !== 'intraday') || (!chart.data.isOneDaySelected && type === 'intraday');

                if (inovestor.ms.core.isNullOrUndefined(symbolsList))
                    throw 'No Symbols detected';

                // Always remove the intraday plot line when getting new data as it needs to be calculated.
                chart._removeIntradayClosePlotLine();

                // Update options
                chart.data.isOneDaySelected = type === 'intraday';
                plugin.options.chartCompareModeEnabled = symbolsList.length > 1;

                // Get Data
                if (!chart.data.isOneDaySelected) {
                    var cacheKey = "daily." + symbolsList.join(',');
                    var cachedData = plugin._apiCache(cacheKey);
                    if (cachedData) {
                        chart._updateAndSetupChartData(cachedData, null, type, count, isChangingMode);
                        defer.resolve();
                    }
                    else {
                        chart._getStockDailyData(symbolsList).then(function (data) {
                            plugin._apiCache(cacheKey, data);
                            chart._updateAndSetupChartData(data, null, type, count, true);
                            defer.resolve();
                        });
                    }
                }
                else {
                    $.when(chart._getIntradayData(symbolsList), chart._getQuoteData(symbolsList)).then(function (intradayResult, quoteResult) {
                        // Each argument is an array with the following structure: [ data, statusText, jqXHR ] (because of jQuery)
                        chart._updateAndSetupChartData(intradayResult[0], quoteResult[0], type, count, isChangingMode);
                        defer.resolve();
                    });
                }

                return defer.promise();
            },
            convertChartDataToChartDataSet: function (chartData) {
                if (inovestor.ms.core.isNullOrUndefined(chartData) || inovestor.ms.core.isNullOrUndefined(chartData.fields) || inovestor.ms.core.isNullOrUndefined(chartData.datas))
                    return [];

                var convertedData = [];
                var dateIndex = chartData.fields.indexOf("date");
                var openIndex = chartData.fields.indexOf("open");
                var highIndex = chartData.fields.indexOf("high");
                var lowIndex = chartData.fields.indexOf("low");
                var closeIndex = chartData.fields.indexOf("close");
                var volumeIndex = chartData.fields.indexOf("volume");

                if (this.getChartType() == 'ohlc' || this.getChartType() == 'candlestick') {
                    for (var i in chartData.datas) {
                        var date = moment.utc(chartData.datas[i][dateIndex]).valueOf();
                        convertedData.push([
                            date,
                            chartData.datas[i][openIndex],
                            chartData.datas[i][highIndex],
                            chartData.datas[i][lowIndex],
                            chartData.datas[i][closeIndex],
                            chartData.datas[i][volumeIndex]
                        ]);
                    }
                }
                else {
                    for (var i in chartData.datas) {
                        var date = moment.utc(chartData.datas[i][dateIndex]).valueOf();
                        convertedData.push([
                            date,
                            chartData.datas[i][closeIndex],
                            chartData.datas[i][highIndex],
                            chartData.datas[i][lowIndex],
                            chartData.datas[i][openIndex],
                            chartData.datas[i][volumeIndex]
                        ]);
                    }
                }

                return convertedData;
            },

            getChartConfig: function (isInCompareMode) {
                var resource = inovestor.ms.core.getCurrentResource(inovestor.ms.chart.historical.resources);
                var getChartType = this.getChartType;

                return {
                    chart: {
                        zoomType: chart.data.showNavigator ? 'x' : '',
                        marginBottom: chart.data.showNavigator ? 15 : undefined,
                        height: chart.data.height ? chart.data.height : plugin.options.isMobile ? 250 : undefined,
                        panning: false,
                        pinchType: false,
                        styledMode: plugin.options.styledMode ? plugin.options.styledMode : false
                    },
                    rangeSelector: {
                        buttons: [],
                        enabled: false,
                        inputEnabled: false
                    },
                    navigator: {
                        enabled: chart.data.showNavigator
                    },
                    scrollbar: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            color: '#538dac',
                            fillColor: 'rgba(203, 221, 230, 0.70)',
                            turboThreshold: 0,
                            states: {
                                hover: {
                                    enabled: false
                                }
                            },
                            animation: false,
                            dataGrouping: {
                                enabled: false,
                                dateTimeLabelFormats: {
                                    week: [resource.stockTooltip.week + ' %A,  %b %d, %Y']
                                }
                            }
                        },

                    },
                    xAxis: {
                        type: 'datetime',
                        ordinal: chart.data.isOneDaySelected ? false : true,
                        tickInterval: chart.data.isOneDaySelected ? 3600 * 1000 : 3 * 30 * 24 * 3600 * 1000,
                        labels: {
                            format: chart.data.isOneDaySelected ? '{value:%H:%M}' : '{value:%b %Y}',
                            rotation: 0
                        },
                    },
                    yAxis: chart.data.showNavigator ? [
                        {
                            height: plugin.options.isMobile ? '70%' : "81%",
                            offset: 45,
                            labels: {
                                style: {
                                    fontSize: '10.5px'
                                },
                                formatter: function () {
                                    var value = Highcharts.numberFormat(this.value, 2);
                                    if (plugin.options.chartCompareModeEnabled) {
                                        value = "";
                                        if (this.value > 0)
                                            value = "+";

                                        value += Highcharts.numberFormat(this.value, 2) + "%";
                                    }
                                    return value;
                                },
                            }
                        },
                        {
                            title: { text: resource.stockChartVolume },
                            top: '85%',
                            height: '15%',
                            offset: 45,
                            showLastLabel: true,
                            tickPositioner: function () {
                                var positions = [];
                                positions.push(0);
                                if (this.max) {
                                    positions.push(this.max / 2);
                                    positions.push(this.max);
                                }

                                return positions;
                            },
                            labels: {
                                style: {
                                    fontSize: '10.5px'
                                },
                                formatter: function () {
                                    if (this.value) {
                                        if (this.axis.max && this.axis.max > 1000000) {
                                            return Highcharts.numberFormat(this.value / 1000000, 2) + 'M';
                                        }
                                        else {
                                            return Highcharts.numberFormat(this.value / 1000, 0) + 'K';
                                        }
                                    }
                                    else {
                                        return null;
                                    }
                                }
                            }
                        }]
                        :
                        [{
                            height: '100%',
                            labels: {
                                align: 'left',
                                style: {
                                    fontSize: '10.5px'
                                },
                                formatter: function () {
                                    var value = Highcharts.numberFormat(this.value, 2);
                                    if (plugin.options.chartCompareModeEnabled) {
                                        value = "";
                                        if (this.value > 0)
                                            value = "+";

                                        value += Highcharts.numberFormat(this.value, 2) + "%";
                                    }
                                    return value;
                                },
                            }
                        }],
                    tooltip: {
                        headerFormat: '<div><small>{point.key}</small></div>',
                        footerFormat: '',
                        style: {
                            lineHeight: plugin.options.isMobile ? '10px' : '1.5em'
                        },
                        pointFormatter: function () {
                            var seriesData = plugin._chartTooltipData[this.series.name] ? plugin._chartTooltipData[this.series.name] : null;
                            if (seriesData == null || this.x == null)
                                return null;

                            var dataPoint = null;
                            var date = new Date(this.x);
                            for (var iCnt = 0; iCnt < seriesData.data.length; iCnt++) {
                                var itemDate = new Date(seriesData.data[iCnt][0]);

                                //series is always in right order. We take the first to be greater or equal in case of market closed during the week.
                                if (itemDate.getTime() >= date.getTime()) {
                                    dataPoint = seriesData.data[iCnt];
                                    break;
                                }
                            }

                            if (dataPoint == null)
                                return null;

                           
                            var format = ''
                            if (plugin.options.isMobile) {
                                 format =
                                    '<span style="color:{color};font-weight:bold;font-size:60%">{serieName}</span><br/>'
                            } else {
                                format =
                                    '<span style="color:{color};font-weight:bold;">{serieName}</span><br/>' +
                                    '<span style="color:#888;font-weight:bold;">' + resource.stockTooltip.open + ':  </span>' +
                                    '<span style="font-size:12px;color:{color}">{open}</span>' +
                                    '<span style="color:#888;font-weight:bold;"> ' + resource.stockTooltip.high + ':  </span>' +
                                    '<span style="font-size:12px;color:{color}">{high}</span>' +
                                    '<span style="color:#888;font-weight:bold;"> ' + resource.stockTooltip.low + ':  </span>' +
                                    '<span style="font-size:12px;color:{color}">{low}</span>' +
                                    '<span style="color:#888;font-weight:bold;"> ' + resource.stockTooltip.close + ':  </span>' +
                                    '<span style="font-size:12px;color:{color}">{close}</span><br/>';
                            }

                            if (!inovestor.ms.core.isNullOrUndefined(dataPoint[5]) && !plugin.options.isMobile)
                                format += '<span style="color:#888;font-weight:bold;">' + resource.stockTooltip.volume + ':  </span>' +
                                    '<span style="font-size:12px;color:{color}">{volume}</span><br/>';

                            var seriesName = !this.change ? seriesData.name : seriesData.name + ' (' + Highcharts.numberFormat(this.change, 2) + '%)';

                            if (getChartType() == 'ohlc' || getChartType() == 'candlestick') {
                                var tooltip = inovestor.ms.core.stringFormat(format, {
                                    color: this.color,
                                    serieName: seriesName,
                                    close: Highcharts.numberFormat(dataPoint[4], 2),
                                    high: Highcharts.numberFormat(dataPoint[2], 2),
                                    open: Highcharts.numberFormat(dataPoint[1], 2),
                                    low: Highcharts.numberFormat(dataPoint[3], 2),
                                    volume: Highcharts.numberFormat(dataPoint[5], 0)
                                });
                            }
                            else {
                                var tooltip = inovestor.ms.core.stringFormat(format, {
                                    color: this.color,
                                    serieName: seriesName,
                                    close: Highcharts.numberFormat(dataPoint[1], 2),
                                    high: Highcharts.numberFormat(dataPoint[2], 2),
                                    open: Highcharts.numberFormat(dataPoint[4], 2),
                                    low: Highcharts.numberFormat(dataPoint[3], 2),
                                    volume: Highcharts.numberFormat(dataPoint[5], 0)
                                });
                            }

                            return tooltip;
                        }

                    },
                    series: [],
                    navigation: {
                        buttonOptions: {
                            theme: {
                                r: 3,
                                states: {
                                    stroke: 'none',
                                    hover: {
                                        fill: '#eee',
                                        stroke: 'none',
                                    },
                                    select: {
                                        stroke: 'none',
                                        fill: '#ddd'
                                    }
                                }
                            }
                        },
                        menuItemStyle: {
                            fontSize: '13px'
                        },
                        menuItemHoverStyle: {}
                    }
                };

            },
            getChartType: function () {
                var defaultType = 'line';
                // Only line is supported in compare mode for now
                if (plugin.options.chartCompareModeEnabled)
                    return 'line';

                switch (plugin.options.chartType.toLowerCase()) {
                    case 'line':
                        return plugin.options.chartType.toLowerCase();
                    case 'area':
                    case 'ohlc':
                    case 'candlestick':
                        // Check if other symbols to load
                        if (inovestor.ms.core.isNullOrUndefined(plugin._otherSeriesDataSources) || !$.isArray(plugin._otherSeriesDataSources) || plugin._otherSeriesDataSources)
                            return plugin.options.chartType.toLowerCase();
                        else
                            return defaultType;
                    default:
                        throw "Cannot render a '" + plugin.options.chartType + "' chart for stocks";
                }
            },

            _updateAndSetupChartData: function (chartData, quoteData, type, count, isChangingMode) {
                if (Array.isArray(chartData) && chartData.length === 0) {
                    chart.destroy();
                    plugin.$element.addClass('hidden');
                    return;
                }

                if (!inovestor.ms.core.isNullOrUndefined(chartData)) {
                    chart._updateStockSeriesData(chartData);
                }

                if (isChangingMode) {
                    // WORKAROUND: this is to fix highchart issue when the series cannot change extremes without loading ALL first...
                    plugin._setChartExtremes('all', null, false);
                }

                if (chart.data.isOneDaySelected) {
                    // Update stock series
                    plugin._chartInstance.xAxis[0].update({
                        ordinal: false,
                        tickInterval: 3600 * 1000,
                        labels: {
                            formatter: function () {
                                if (!plugin.options.isMobile)
                                    return Highcharts.dateFormat('%H:%M', this.value);

                                var index = 0;
                                for (var prop in this.axis.ticks)
                                    index++;
                                return index % 2 == 0 ? Highcharts.dateFormat('%H:%M', this.value) : '';
                            }
                        }
                    }, false);

                    if (chart.data.showNavigator) {
                        // Update navigator series
                        plugin._chartInstance.xAxis[1].update({ ordinal: false, tickInterval: 3600 * 1000 }, false);
                    }

                    // Set the extremes
                    chart._setIntraDayDateExtremes();

                    // Add the intraday close plotline
                    chart._addIntradayClosePlotLine(quoteData);

                    setTimeout(function () {
                        if (plugin.options.isMobile)
                            plugin._autoSelectLastPoint();
                    });
                }
                else {
                    var xLabelsFormat = '{value:%b %Y}';
                    var tickInterval = 3 * 30 * 24 * 3600 * 1000;
                    if (chart.data.zoomType == "month" && chart.data.zoomCount < 6) {
                        tickInterval = 14 * 24 * 3600 * 1000;
                        xLabelsFormat = '{value:%b %d}' + (plugin.options.isMobile ? '<br/>{value:%Y}' : '');
                    }
                    plugin._chartInstance.xAxis[0].update({ ordinal: true, tickInterval: tickInterval, labels: { format: xLabelsFormat, formatter: null } }, false);
                    if (chart.data.showNavigator)
                        plugin._chartInstance.xAxis[1].update({ ordinal: true }, false);
                    plugin._setChartExtremes(type, count);
                    // Re-select the last point that isnt intra day
                    if (isChangingMode) {
                        if (plugin.options.isMobile)
                            plugin._autoSelectLastPoint();
                    }
                }

                plugin._chartInstance.redraw();
            },
            _updateStockSeriesData: function (data) {
                // Reset required data
                plugin._chartTooltipData = [];

                var otherSeriesData = [];
                var symbolIndex = 0;
                for (var symbol in plugin._symbols) {
                    for (var index in data) {
                        if (data[index].symbol.toLowerCase() === symbol.toLowerCase()) {
                            if (symbolIndex === 0)
                                plugin._mainSerieDataSource = data[index];
                            else
                                otherSeriesData.push(data[index]);
                        }
                    }
                    symbolIndex++;
                }
                plugin._otherSeriesDataSources = otherSeriesData;
                plugin._updateChartSeries();
            },
            _addFullScreenButton: function () {
                var resource = inovestor.ms.core.getCurrentResource(inovestor.ms.chart.historical.resources);

                var html =
                    '<div class="fullscreen-btn-icon" tabindex="0" role="button" aria-label="' + resource.fullscreenButtonAriaLabel + '">' +
                    '<span class="fa-stack fa-xs">' +
                    '<i class="fa fa-square fa-stack-2x"></i>' +
                    '<i class="fa fa-arrows-alt fa-stack-1x fa-inverse"></i>' +
                    '</span>' +
                    '</div>';

                chart.data.$actionBarElement.append(html);

                var chartSize = { width: 0, height: 0 };
                chart.data.$actionBarElement.find('.fullscreen-btn-icon').on('click', function () {
                    if (plugin.$element.hasClass('fullscreen')) {
                        plugin.$chartElement.find('.highcharts-container').width(chartSize.width);
                        plugin.$chartElement.find('.highcharts-container').height(chartSize.height);
                        plugin.$element.removeClass('fullscreen');
                        $(this).find('.fa-stack-1x').removeClass('fa-close').addClass('fa-arrows-alt');
                    }
                    else {
                        chartSize.width = plugin.$chartElement.width();
                        chartSize.height = plugin.$chartElement.height();
                        plugin.$element.addClass('fullscreen');
                        $(this).find('.fa-stack-1x').removeClass('fa-arrows-alt').addClass('fa-close');
                    }
                    plugin._chartInstance.reflow();
                });

                // to improve keyboard navigation, simulate a click when pressing enter on the fullscreen button
                chart.data.$actionBarElement.find('.fullscreen-btn-icon').on('keydown', function (e) {
                    if (e.keyCode === 13) {
                        $(this).click();
                    }
                });

                // to improve keyboard navigation, close fullscreen mode when pressing escape
                $('body').on('keydown', function (e) {
                    if (e.keyCode === 27 && plugin.$element.hasClass('fullscreen')) {
                        chart.data.$actionBarElement.find('.fullscreen-btn-icon').click();
                    }
                });
            },
            _addTimespanSelectors: function () {
                var resource = inovestor.ms.core.getCurrentResource(inovestor.ms.chart.historical.resources);

                // Add all the timespan selectors
                var html =
                    '<div class="zooms">' +
                    '<span>' + resource.zoom.zoom + '</span>' +
                    '<a ' + (chart.data.isOneDaySelected ? 'class="active" ' : '') + 'type="intraday" tabindex="0">' + resource.zoom.oneDay + '<span class="bg-primary"></span></a>' +
                    '<a type="month" count="1" tabindex="0">' + resource.zoom.oneMonth + '<span class="bg-primary"></span></a>' +
                    '<a type="month" count="3" tabindex="0">' + resource.zoom.threeMonths + '<span class="bg-primary"></span></a>' +
                    '<a ' + (!chart.data.isOneDaySelected ? 'class="active" ' : '') + 'type="month" count="6" tabindex="0">' + resource.zoom.sixMonths + '<span class="bg-primary"></span></a>' +
                    '<a class="optional" type="ytd" tabindex="0">' + resource.zoom.ytd + '<span class="bg-primary"></span></a>' +
                    '<a type="year" count="1" tabindex="0">' + resource.zoom.oneYear + '<span class="bg-primary"></span></a>' +
                    '<a type="all" tabindex="0">' + resource.zoom.all + '<span class="bg-primary"></span></a>' +
                    '</div>';
                chart.data.$actionBarElement.append(html);

                // Add the onclick events
                chart.data.$actionBarElement.find('.zooms a').on('click', function (e) {
                    var zoomEle = chart.data.$actionBarElement.find('.zooms');

                    if (zoomEle.hasClass('busy')) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    zoomEle.addClass('busy');
                    var selectedEle = $(this);
                    var type = selectedEle.attr('type'),
                        count = parseInt(selectedEle.attr('count'));

                    chart.data.$actionBarElement.find('.zooms a').not(selectedEle).removeClass('active');
                    selectedEle.addClass('active');

                    chart.data.zoomType = type;
                    chart.data.zoomCount = count;

                    chart.updateData().then(function () {
                        zoomEle.removeClass('busy');
                    });
                });

                chart.data.$actionBarElement.find('.zooms a').on('keydown', function (e) {
                    if (e.keyCode === 13) {
                        $(this).click();
                    }
                });
            },
            _addIndexSelectors: function () {
                // Add all the timespan selectors
                var html = '<div class="indexes">';
                for (var i in plugin.options.otherSymbols) {
                    var otherSymbol = plugin.options.otherSymbols[i];
                    var name = otherSymbol.nameEn;
                    var square = otherSymbol.selected ? 
                        '<i class="fa fa-check-square-o" style="margin-right:5px;" role="checkbox" aria-checked="true" aria-label="' + name + '" tabindex="0"></i>' : 
                        '<i class="fa fa-square-o" style="margin-right:5px;" role="checkbox" aria-checked="false" aria-label="' + name + '" tabindex="0"></i>';
                    html += '<a class="state" symbol="' + otherSymbol.symbol + '">' + square + name + '</a>';
                }
                html += '</div>';
                chart.data.$actionBarElement.append(html);

                // Add the onclick events
                chart.data.$actionBarElement.find('.indexes a').on('click', function () {
                    var symbol = $(this).attr('symbol');
                    var otherSymbol = null;
                    for (var i in plugin.options.otherSymbols) {
                        if (plugin.options.otherSymbols[i].symbol === symbol) {
                            otherSymbol = plugin.options.otherSymbols[i];
                            break;
                        }
                    }

                    if (!inovestor.ms.core.isNullOrUndefined(otherSymbol)) {
                        var isSelected = $(this).find('.fa-check-square-o').length > 0;
                        otherSymbol.selected = !isSelected;
                        if (otherSymbol.selected) {
                            plugin._symbols[symbol] = 1;
                            $(this).find('.fa').addClass('fa-check-square-o').removeClass('fa-square-o').attr('aria-checked', 'true');
                        }
                        else {
                            delete plugin._symbols[symbol];
                            $(this).find('.fa').removeClass('fa-check-square-o').addClass('fa-square-o').attr('aria-checked', 'false');
                        }

                        plugin.search(plugin.options.symbols);
                    }

                });

                // to improve keyboard navigation, simulate a click when pressing enter on the index selector
                chart.data.$actionBarElement.find('.indexes a').on('keydown', function (e) {
                    if (e.keyCode === 13 || e.keyCode === 32) {
                        e.preventDefault();
                        $(this).click();
                    }
                });
            },
            _addChartTypeDropdown: function () {
                var resource = inovestor.ms.core.getCurrentResource(inovestor.ms.chart.historical.resources);

                // Add all the timespan selectors
                var html =
                    '<div class="chart-types">' +
                    '<div class="dropdown">' +
                    '<button class="dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true">' +
                    resource.chartType.title +
                    '&nbsp;<span class="caret"></span></button>' +
                    '<ul class="dropdown-menu">' +
                    '<li><a chartType="line" href="#">' + resource.chartType.line + '</a></li>' +
                    '<li><a chartType="candlestick" href="#">' + resource.chartType.candlestick + '</a></li>' +
                    '<li><a chartType="area" href="#">' + resource.chartType.mountain + '</a></li>' +
                    '<li><a chartType="ohlc" href="#">' + resource.chartType.ohlc + '</a></li>' +
                    '</ul>' +
                    '</div>' +
                    '</div>';
                chart.data.$actionBarElement.append(html);

                // Add the onclick events
                chart.data.$actionBarElement.find('.chart-types a').on('click', function (e) {
                    e.preventDefault();

                    var chartType = $(this).attr('chartType');

                    plugin.options.chartType = chartType;
                    plugin._updateChartSeries();
                    chart._updateAndSetupChartData();
                });

            },
            _getStockDailyData: function (symbols) {
                // Make sure required variables are set
                if (inovestor.ms.core.isNullOrUndefined(symbols))
                    throw "symbolsList is required";

                // Setup API url with term
                var historicalStockApiUrl = inovestor.ms.core.stringFormat(inovestor.ms.chart.historical.config.apiStocksRelativeUrl, { symbols: symbols.join(',') });
                var options = {
                    type: 'GET', contentType: 'application/json', error: function (error) {
                        plugin.apiErrorHandler(error);
                    }
                };
                return inovestor.ms.core.ajaxApi(historicalStockApiUrl, options);
            },
            _getIntradayData: function (symbols) {
                // Make sure required variables are set
                if (inovestor.ms.core.isNullOrUndefined(symbols))
                    throw "symbolsList is required";

                // Setup API url with term
                var intraDayApiUrl = inovestor.ms.core.stringFormat(inovestor.ms.chart.historical.config.apiIntraDayUrl, { symbols: symbols.join(',') });
                var options = {
                    type: 'GET', contentType: 'application/json', error: function (error) {
                        plugin.apiErrorHandler(error);
                    }
                };
                return inovestor.ms.core.ajaxApi(intraDayApiUrl, options);
            },
            _getQuoteData: function (symbols) {
                // Make sure required variables are set
                if (inovestor.ms.core.isNullOrUndefined(symbols))
                    throw "symbolsList is required";

                // Setup API url with term
                var apiUrl = inovestor.ms.core.stringFormat(inovestor.ms.chart.historical.config.apiQuoteUrl, { symbols: symbols.join(',') });
                var options = {
                    type: 'GET', contentType: 'application/json', error: function (error) {
                        plugin.apiErrorHandler(error);
                    }
                };
                return inovestor.ms.core.ajaxApi(apiUrl, options);
            },
            _setIntraDayDateExtremes: function () {
                var minDateSettings = { 'hour': 9, 'minute': 30, 'second': 0, 'millisecond': 0 };
                var maxDateSettings = { 'hour': 16, 'minute': 0, 'second': 0, 'millisecond': 0 };
                var minDate = moment().utc().set(minDateSettings);
                var maxDate = moment().utc().set(maxDateSettings);

                var mainData = plugin._mainSerieDataSource.datas;
                if (!inovestor.ms.core.isNullOrUndefined(mainData) && mainData.length > 0) {
                    // If there's data coming from the API, use the first datapoint to set min and max dates.
                    // This is to handle cases when markets are closed.
                    // We can do this because intraday means we only get a single day worth of data.
                    var apiDate = mainData[0][0];

                    // Set the min and max hours based on the date.
                    minDate = moment(apiDate).utc().set(minDateSettings);
                    maxDate = moment(apiDate).utc().set(maxDateSettings);
                }

                // Set the min and max for the x-axis and call setExtremes so the navigator selects all.
                plugin._chartInstance.xAxis[0].update({min: +minDate, max: +maxDate});
                plugin._chartInstance.xAxis[0].setExtremes(+minDate, +maxDate, false, false);
            },
            _addIntradayClosePlotLine: function (quoteData) {
                if (!inovestor.ms.core.isNullOrUndefined(quoteData) && plugin._getSymbols().length === 1) {
                    var close = quoteData[0].previousClose;
                    var datas = plugin._mainSerieDataSource.datas;

                    if (!inovestor.ms.core.isNullOrUndefined(close) && !inovestor.ms.core.isNullOrUndefined(datas) && datas.length > 0) {

                        // Highcharts will not show the plotline if it's not in the range of the chart data.
                        // To counter this, we find the min and max of the series and, if the value
                        // of the plotline is either bigger or smaller the the min or max, we set the extremes
                        // to the value of the plotline.

                        var prices = datas.map(function (data) {
                            return data[1];
                        });
                        var min = Math.min.apply(Math, prices);
                        var max = Math.max.apply(Math, prices);
                        var minExtreme = min > close ? close : null;
                        var maxExtreme = max < close ? close : null;

                        if (minExtreme || maxExtreme) {
                            plugin._chartInstance.yAxis[0].setExtremes(minExtreme, maxExtreme);
                        }

                        // Finally, just add the plotline to the chart.
                        var resource = inovestor.ms.core.getCurrentResource(inovestor.ms.chart.historical.resources);
                        plugin._chartInstance.yAxis[0].addPlotLine({
                            id: 'lastclose',
                            color: '#d9534f',
                            width: 1,
                            value: close,
                            dashStyle: 'shortdash',
                            label: {
                                useHTML: true,
                                rotation: 0,
                                text: resource.lastClose + '<br/>' + Highcharts.numberFormat(close, 2),
                                style: {
                                    color: '#d9534f',
                                    fontSize: '11px',
                                    lineHeight: '15px',
                                    paddingTop: '3px'
                                },
                                align: 'right'
                            },
                            zIndex: 3
                        });
                    }
                }
            },
            _removeIntradayClosePlotLine: function () {
                // Remove the plotline by id.
                plugin._chartInstance.yAxis[0].removePlotLine('lastclose');
                // Reset the extremes so the chart renders correctly in other modes.
                plugin._chartInstance.yAxis[0].setExtremes(null, null);
            },
        };

        return chart;
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.highcharts, inovestor.ms.chart.historical);


; (function ($, Highcharts, inovestor, undefined) {

    var pluginName = 'inoMsChartHistorical';

    // Create the plugin constructor
    function Plugin(element, options) {

        this.element = element;
        this.chart = null;
        this._name = pluginName;
        this._defaults = $.fn.inoMsChartHistorical.defaults;
        this._symbols = {};
        this._chartInstance = null;
        this._mainSerieId = inovestor.ms.core.getPseudoGuid();
        this._mainSerieDataSource = null;
        this._otherSeriesDataSources = null;
        this._chartTooltipData = null;
        this._apiCacheVar = {};

        // Merge options with defaults
        this.options = $.extend({}, this._defaults, options);

        // Make sure required variables are set
        if (inovestor.ms.core.isNullOrUndefined(this.options.symbols))
            throw "symbols is required";
        if (inovestor.ms.core.isNullOrUndefined(this.options.type))
            throw "type is required";
        if (inovestor.ms.core.isNullOrUndefined(inovestor.ms.chart.historical.charts[this.options.type]))
            throw "type '" + this.options.type + "' is not supported";

        // If isMobile is not set, check the width of the rendered element to see if it is smaller than 650px
        if (inovestor.ms.core.isNullOrUndefined(this.options.isMobile))
            this.options.isMobile = $(element).width() <= 650;

        // Init plugin chart object
        this.chart = inovestor.ms.chart.historical.charts[this.options.type].call(this);

        // Call init
        this.init();
    }

    $.extend(Plugin.prototype, {

        // Initialization logic
        init: function () {
            var plugin = this;

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                // Need to re-render because of chart resources
                plugin.update();
            });

            plugin.buildCache();
            plugin.bindEvents();
            if (plugin.options.isMobile)
                plugin.$element.addClass('mobile');
            plugin.chart.init();
            plugin.render();

            // Call Search
            plugin.search(plugin.options.symbols).always(function () {
                // When search is completed, trigger onReady event
                plugin.$element.trigger('ready' + '.' + plugin._name);
            });
        },

        // Remove plugin instance completely
        destroy: function () {
            this.unbindEvents();
            this.destroyHighChart();
            this.$element.removeData();
            this.$element.html('');
            this.chart.destroy();
        },

        // Remove highchart instance
        destroyHighChart: function () {
            if (!inovestor.ms.core.isNullOrUndefined(this.$chartElement)) {
                if (!inovestor.ms.core.isNullOrUndefined(this._chartInstance))
                    this._chartInstance.destroy();
                this.$chartElement.remove();
                this.$chartElement = null;
            }
            this.chart.destroy();
        },

        // Cache DOM nodes for performance
        buildCache: function () {
            this.$element = $(this.element);
        },

        // Bind events that trigger methods
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('ready' + '.' + plugin._name, function () {
                var onReady = plugin.options.onReady;
                if (typeof onReady === 'function')
                    onReady.call(plugin.$element);
            });

        },

        // Unbind events that trigger methods
        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        // Main API error handler
        apiErrorHandler: function (apiError) {
            var plugin = this;
            plugin._apiCacheVar = {};
            plugin.destroyHighChart();
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.apiError, apiError, plugin));

                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }
            plugin.$element.append(inovestor.ms.core.getErrorTemplate(inovestor.ms.core.currentLanguage));

        },

        // Main API error handler
        invalidIdentifierHandler: function () {
            var plugin = this;
            plugin._apiCacheVar = {};
            plugin.destroyHighChart();
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.invalidIdentifier, null, plugin));

                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }
            plugin.$element.append(inovestor.ms.core.getInvalidIdentifierTemplate(inovestor.ms.core.currentLanguage));
        },

        openFullScreen: function () {

        },

        // Renders html template
        // REQUIRED : chart methods: beforeRender() and afterRender()
        render: function () {
            var plugin = this;

            plugin.$element.addClass('ino-ms-chart');
            plugin.$element.html('');
            plugin.chart.beforeRender();

            plugin.destroyHighChart();

            plugin.$loadingIndicatorElement = $('<div class="chart-loading-indicator"></div>');
            plugin.$element.append(plugin.$loadingIndicatorElement);

            plugin.$chartElement = $('<div id="chart-element' + plugin._mainSerieId + '" class="historical-chart"></div>');
            plugin.$element.append(plugin.$chartElement);

            plugin._renderChart();
            plugin.chart.afterRender();
        },

        // Search for a list stocks/funds
        search: function (symbols) {
            var plugin = this;

            // Update symbols list if it changes
            if (!inovestor.ms.core.isNullOrUndefined(symbols)) {
                plugin.options.symbols = symbols;
                // Build symbols list
                plugin._buildSymbols();
            }

            if (inovestor.ms.core.isNullOrUndefined(plugin.$chartElement))
                plugin.render();

            // Make sure required variables are set
            if (inovestor.ms.core.isNullOrUndefined(plugin._symbols))
                throw "symbols is required";

            // Reset relevant Data before calling API
            plugin._mainSerieDataSource = null;
            plugin._otherSeriesDataSources = null;
            plugin._chartTooltipData = null;

            // Keep track of the focused element (if any)
            // We will refocus on it after the chart is updated (to improve keyboard navigation)
            var focusedElement = plugin.$element.find(':focus');

            plugin.$loadingIndicatorElement.html(inovestor.ms.core.getLoadingIndicatorTemplate(inovestor.ms.core.currentLanguage));
            plugin.$loadingIndicatorElement.show();

            plugin.chart.beforeUpdateData();

            return plugin.chart.updateData().then(function () {
                plugin.$loadingIndicatorElement.hide();
                plugin.$loadingIndicatorElement.html('');

                if (plugin.options.isMobile)
                    plugin._autoSelectLastPoint();

                if (!inovestor.ms.core.isNullOrUndefined(plugin._mainSerieDataSource) && plugin._mainSerieDataSource.requestStatus === 'invalidIdentifier')
                    plugin.invalidIdentifierHandler();

                plugin.chart.afterUpdateData();

                if (focusedElement.length > 0) {
                    focusedElement.focus();
                }
            });
        },

        _autoSelectLastPoint: function () {
            var plugin = this;

            // show tooltip on last point when mobile
            var dataPoints = plugin._chartInstance.series[0].points;
            if (dataPoints) {
                lastPoint = dataPoints[dataPoints.length - 1];
                if (!lastPoint || lastPoint.y == null)
                    lastPoint = dataPoints[dataPoints.length - 2];
                plugin._chartInstance.tooltip.refresh([lastPoint]);
            }
        },

        // Sets up a Highchart with 2 series 
        // REQUIRED : chart method getChartConfig()
        _renderChart: function () {
            var plugin = this;

            var chartConfig = plugin.chart.getChartConfig();
            var mainColor = Highcharts.getOptions().colors[0];

            // Set a serie that will hold the MAIN symbol data 
            chartConfig.series.push({
                id: plugin._mainSerieId,
                name: plugin._mainSerieId,
                type: plugin.chart.getChartType(),
                yAxis: 0,
                threshold: null,
                color: mainColor,
                data: []
            });

            if (!inovestor.ms.core.isNullOrUndefined(plugin.chart.data.showVolume) && plugin.chart.data.showVolume === true) {
                // Set the volume serie of the MAIN 
                chartConfig.series.push({
                    id: plugin._mainSerieId + ':Volume',
                    name: plugin._mainSerieId + ':Volume',
                    type: 'column',
                    yAxis: 1,
                    color: mainColor,
                    data: []
                });
            }

            // Create new highchart instance, deleting old one first
            plugin._chartInstance = Highcharts.stockChart('chart-element' + plugin._mainSerieId, chartConfig);
        },

        // Update the chart data / resources based on current localization
        update: function () {
            var plugin = this;
            // Re-render chart
            plugin._apiCacheVar = {};
            plugin.render();
            plugin.search(plugin.options.symbols);
        },

        // Getter / Setter method in order to store api calls
        _apiCache: function (key, cacheValue) {
            var plugin = this;

            if (inovestor.ms.core.isNullOrUndefined(key))
                return null;

            if (typeof cacheValue === 'undefined') {
                var val = plugin._apiCacheVar[key];
                if (inovestor.ms.core.isNullOrUndefined(val))
                    return val;
                if ($.isArray(val))
                    return val.slice();
                else
                    return $.extend(true, {}, val);
            }

            if ($.isArray(cacheValue))
                plugin._apiCacheVar[key] = cacheValue.slice();
            else
                plugin._apiCacheVar[key] = $.extend(true, {}, cacheValue);
            return cacheValue;
        },

        // Methods for Building symbols list object and to get the selected symbols array
        _buildSymbols: function () {
            // Use the symbols in options with the selected symbols in otherSymbols to 
            // generate a list of currently selected symbols, the first in index being the main symbol
            var plugin = this;
            var symbols = plugin.options.symbols;

            // Reset symbols list
            plugin._symbols = {};

            var symbolsList = [];
            if (typeof symbols == 'string') {
                if (symbols.split(',').length > 1)
                    symbolsList = symbols.split(',');
                else
                    symbolsList.push(symbols);
            }
            else if ($.isArray(symbols))
                symbolsList = symbols;

            if (!inovestor.ms.core.isNullOrUndefined(plugin.options.otherSymbols) && $.isArray(plugin.options.otherSymbols)) {
                for (var i in plugin.options.otherSymbols) {
                    if (plugin.options.otherSymbols[i].selected)
                        symbolsList.push(plugin.options.otherSymbols[i].symbol);
                }
            }

            for (var i in symbolsList)
                plugin._symbols[symbolsList[i]] = 1;
        },
        _getSymbols: function () {
            // Retun array of selected symbols using the plugin _symbols object
            var plugin = this;
            var symbolsList = [];

            for (var i in plugin._symbols)
                symbolsList.push(i);

            return symbolsList;
        },

        _updateMainSeries: function () {
            var plugin = this;
            var mainData = plugin._mainSerieDataSource;
            var convertedMainData = plugin.chart.convertChartDataToChartDataSet(mainData);

            // Get required data
            var colors = Highcharts.getOptions().colors;
            var mainSeries = plugin._chartInstance.get(plugin._mainSerieId);
            var mainSeriesVolume = plugin._chartInstance.get(plugin._mainSerieId + ':Volume');
            var chartType = plugin.chart.getChartType();

            // Set main series changes
            var mainSeriesChanges = {};
            mainSeriesChanges.data = convertedMainData
            mainSeriesChanges.options = { symbol: mainData.symbol };
            if (mainSeries.type !== chartType)
                mainSeriesChanges.type = chartType;
            // Update Series 
            if (mainSeriesChanges.data || mainSeriesChanges.options || mainSeriesChanges.type)
                mainSeries.update(mainSeriesChanges, false);

            // Make sure tooltip data is updated to point at correct values
            plugin._chartTooltipData[plugin._mainSerieId] = { name: mainData.symbol, data: convertedMainData };

            // Set main series volume changes
            if (!inovestor.ms.core.isNullOrUndefined(plugin.chart.data.showVolume) && plugin.chart.data.showVolume === true) {
                var mainSeriesVolumeChanges = {};
                mainSeriesVolumeChanges.data = convertedMainData.map(function (item) {
                    return [item[0], item[5]];
                });

                // Update Series 
                if (mainSeriesVolumeChanges.data)
                    mainSeriesVolume.update(mainSeriesVolumeChanges, false);
            }
        },
        _updateOtherSeries: function () {
            var plugin = this;
            var othersData = plugin._otherSeriesDataSources;

            // Get required data
            var colors = Highcharts.getOptions().colors;
            var chartType = plugin.chart.getChartType();

            // Update Other Series Data
            // Remove series if symbol not in plugin ChartDataList
            for (var i in plugin._chartInstance.series) {
                var shouldRemove = true;
                for (var iCnt = 1; iCnt < plugin._otherSeriesDataSources.length; iCnt++) {
                    if (plugin._chartInstance.series[i].name.indexOf(plugin._otherSeriesDataSources[iCnt].symbol) >= 0) {
                        shouldRemove = false;
                        break;
                    }
                }
                if (shouldRemove)
                    plugin._removeSeries(plugin._chartInstance.series[i].name);
            }

            // Add Series if data in ChartDataList not in chart
            for (var iCnt = 0; iCnt < plugin._otherSeriesDataSources.length; iCnt++) {
                var chartData = plugin._otherSeriesDataSources[iCnt];
                var chartSerie = false;
                for (var i in plugin._chartInstance.series) {
                    if (plugin._chartInstance.series[i].name.indexOf(chartData.symbol) >= 0) {
                        // Workaround for SPTSX & SPTSXVEN
                        if (!plugin._chartInstance.series[i].name.match('SPTSX') || !chartData.symbol.match('SPTSX')) {
                            chartSerie = plugin._chartInstance.series[i];
                            break;
                        }
                    }
                }
                if (!chartSerie) {
                    var convertedSeriesData = plugin.chart.convertChartDataToChartDataSet(chartData);
                    var serie = {
                        id: chartData.symbol,
                        name: chartData.symbol,
                        yAxis: 0,
                        color: colors[iCnt + 1],
                        type: chartType,
                        data: convertedSeriesData
                    };
                    plugin._chartInstance.addSeries(serie, false);
                    plugin._chartTooltipData[chartData.symbol] = { name: chartData.symbol, data: convertedSeriesData };
                }
                else {
                    var serieChanges = { type: chartType };
                    chartSerie.update(serieChanges, false);
                }
            }

        },
        _updateChartSeries: function () {
            var plugin = this;

            var defer = $.Deferred();

            plugin._updateMainSeries();
            plugin._updateOtherSeries();

            // Set Chart Compare mode if needed
            if (plugin.options.chartCompareModeEnabled)
                plugin._chartInstance.yAxis[0].setCompare('percent', false);
            else
                plugin._chartInstance.yAxis[0].setCompare(null, false);

            defer.resolve();
            return defer.promise();
        },

        _removeSeries: function (symbol) {
            var plugin = this;
            for (var i in plugin._chartInstance.series) {
                var serie = plugin._chartInstance.series[i];
                if (serie.name.indexOf('Navigator') === -1 && serie.name.indexOf(plugin._mainSerieId) === -1)
                    serie.remove(false);
            }
        },
        _mergeChartDataLists: function (originalChartDatas, additionalChartDatas) {
            if (inovestor.ms.core.isNullOrUndefined(originalChartDatas) || inovestor.ms.core.isNullOrUndefined(originalChartDatas))
                return originalChartDatas;

            for (var i in additionalChartDatas) {
                var additionalChartData = additionalChartDatas[i];
                if (additionalChartData.requestStatus !== 'success')
                    continue;

                var hasBeenFound = false;
                for (var j in originalChartDatas) {
                    var originalChartData = originalChartDatas[j];
                    if (originalChartData.symbol === additionalChartData.symbol) {
                        // Update data
                        originalChartData = additionalChartData.symbol;
                        hasBeenFound = true;
                        break;
                    }
                }
                if (!hasBeenFound)
                    originalChartDatas.push(additionalChartData);
            }
        },

        _setChartExtremes: function (type, count, renderChart) {
            if (inovestor.ms.core.isNullOrUndefined(type))
                return;

            var plugin = this,
                apiFirstDate = null,
                apiLastDate = null,
                minDate = null,
                maxDate = null,
                mainSeries = plugin._chartInstance.get(plugin._mainSerieId),
                currentExtremes = plugin._chartInstance.xAxis[0].getExtremes(),
                renderChart = (inovestor.ms.core.isNullOrUndefined(renderChart) || renderChart !== false);

            var mainData = plugin._mainSerieDataSource.datas;
            if (!inovestor.ms.core.isNullOrUndefined(mainData) && mainData.length > 0) {
                apiFirstDate = new Date(mainData[0][0]);
                apiLastDate = new Date(mainData[mainData.length - 1][0]);
                apiFirstDateUTC = apiFirstDate.setUTCMonth(apiFirstDate.getUTCMonth());
                apiLastDateUTC = apiLastDate.setUTCMonth(apiLastDate.getUTCMonth());
            }
            else
                return;

            switch (type) {
                case 'ytd':
                    maxDate = Date.UTC(apiLastDate.getUTCFullYear(), apiLastDate.getUTCMonth(), apiLastDate.getUTCDate(), apiLastDate.getUTCHours(), apiLastDate.getUTCMinutes(), apiLastDate.getUTCSeconds());
                    minDate = Date.UTC(apiLastDate.getUTCFullYear(), 0, 1, 0, 0, 0);
                    break;
                case 'all':
                    minDate = Date.UTC(apiFirstDate.getUTCFullYear(), apiFirstDate.getUTCMonth(), apiFirstDate.getUTCDate(), apiFirstDate.getUTCHours(), apiFirstDate.getUTCMinutes(), apiFirstDate.getUTCSeconds());
                    maxDate = Date.UTC(apiLastDate.getUTCFullYear(), apiLastDate.getUTCMonth(), apiLastDate.getUTCDate(), apiLastDate.getUTCHours(), apiLastDate.getUTCMinutes(), apiLastDate.getUTCSeconds());
                    break;
                case 'year':
                case 'month':
                    maxDate = currentExtremes.userMax;
                    var tempDate = new Date(currentExtremes.userMax);
                    minDate = type === 'year' ? tempDate.setUTCFullYear(tempDate.getUTCFullYear() - count) : tempDate.setUTCMonth(tempDate.getUTCMonth() - count);
                    if (minDate < apiFirstDateUTC) {
                        minDate = apiFirstDateUTC;
                        tempDate = new Date(apiFirstDateUTC);
                        maxDate = type === 'year' ? tempDate.setUTCFullYear(tempDate.getUTCFullYear() + count) : tempDate.setUTCMonth(tempDate.getUTCMonth() + count);
                        if (maxDate > apiLastDateUTC) {
                            maxDate = apiLastDateUTC;
                        }
                    }
                    break;
                default:
                    throw 'NOOOO';
            }

            plugin._chartInstance.xAxis[0].setExtremes(
                minDate,
                maxDate,
                renderChart,
                false
            );
        },
        _setFundChartExtremes: function (renderChart) {
            var plugin = this,
                apiFirstDate = null,
                apiLastDate = null,
                minDate = null,
                maxDate = null,
                mainSeries = plugin._chartInstance.get(plugin._mainSerieId),
                currentExtremes = plugin._chartInstance.xAxis[0].getExtremes(),
                renderChart = (inovestor.ms.core.isNullOrUndefined(renderChart) || renderChart !== false);

            var mainData = plugin._mainSerieDataSource.historicalDatas;
            if (!inovestor.ms.core.isNullOrUndefined(mainData) && mainData.length > 0) {
                apiFirstDate = new Date(mainData[0].date);
                apiLastDate = new Date(mainData[mainData.length - 1].date);
                apiFirstDateUTC = apiFirstDate.setUTCMonth(apiFirstDate.getUTCMonth());
                apiLastDateUTC = apiLastDate.setUTCMonth(apiLastDate.getUTCMonth());
            }
            else
                return;

            minDate = Date.UTC(apiFirstDate.getUTCFullYear(), apiFirstDate.getUTCMonth(), apiFirstDate.getUTCDate(), apiFirstDate.getUTCHours(), apiFirstDate.getUTCMinutes(), apiFirstDate.getUTCSeconds());
            maxDate = Date.UTC(apiLastDate.getUTCFullYear(), apiLastDate.getUTCMonth(), apiLastDate.getUTCDate(), apiLastDate.getUTCHours(), apiLastDate.getUTCMinutes(), apiLastDate.getUTCSeconds());

            plugin._chartInstance.xAxis[0].setExtremes(
                minDate,
                maxDate,
                renderChart,
                false
            );
        }
    });

    // JQuery Plugin wrapper
    $.fn.inoMsChartHistorical = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };

    // Default options for plugin
    $.fn.inoMsChartHistorical.defaults = {
        symbols: null,
        type: 'fund',
        chartType: 'line',
        chartCompareModeEnabled: false,
        otherSymbols: null,
        chartData: null,
        isMobile: null,
        styledMode: false,
        onError: null,
        onReady: null,
        showTitle: null,
        toolbarOptions: {
            showZoom: true,
            showIndexComparer: true,
            showTypeSwitcher: true,
            showFullScreenButton: true
        }
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.highcharts, inovestor);
; (function (inovestor, undefined) {
    inovestor.ms.chart.historical.resources = inovestor.ms.chart.historical.resources || {};
    inovestor.ms.chart.historical.resources["en"] = {
        chartGrowthTitle: 'Growth of ${growth}',
        chartChangeTitle: 'Historical Data',
        chartType: {
            candlestick: 'Candlestick',
            line: 'Line',
            mountain: 'Mountain',
            ohlc: 'OHLC',
            title: 'Type'
        },
        fundTooltip: {
            balanceLabel: 'Balance',
            balanceValue: '${balance}',
            navpsLabel: 'NAV',
            changeLabel: 'Change',
            changeValue: '{change}%',
        },
        indexes: 'Indexes',
        stockTooltip: {
            close: 'C',
            high: 'H',
            low: 'L',
            open: 'O',
            volume: 'Volume',
            week: 'Week from'
        },
        zoom: {
            zoom: 'Zoom',
            all: 'All',
            oneDay: '1D',
            oneMonth: '1M',
            oneYear: '1Y',
            threeMonths: '3M',
            sixMonths: '6M',
            ytd: 'YTD',
        },
        lastClose: 'Last Close',
        fullscreenButtonAriaLabel: 'Enable/Disable fullscreen mode'
    };
})(inovestor);
; (function (inovestor, undefined) {
    inovestor.ms.chart.historical.resources = inovestor.ms.chart.historical.resources || {};
    inovestor.ms.chart.historical.resources["fr"] = {
        chartGrowthTitle: 'Croissance de {growth} $',
        chartChangeTitle: 'Données historiques',
        chartType: {
            candlestick: 'Chandeliers',
            line: 'Courbe',
            mountain: 'Montagne',
            ohlc: 'Barre',
            title: 'Type'
        },
        fundTooltip: {
            balanceLabel: 'Balance',
            balanceValue: '{balance}$',
            navpsLabel: 'Val. Liq.',
            changeLabel: 'Variation',
            changeValue: '{change}%',
        },
        indexes: 'Indices',
        stockTooltip: {
            close: 'C',
            high: 'H',
            low: 'B',
            open: 'O',
            volume: 'Volume',
            week: 'Semaine du'
        },
        zoom: {
            zoom: 'Zoom',
            all: 'Max',
            oneDay: '1J',
            oneMonth: '1M',
            oneYear: '1A',
            threeMonths: '3M',
            sixMonths: '6M',
            ytd: 'Année',
        },
        lastClose: 'Dernière clôture',
        fullscreenButtonAriaLabel: 'Activer/Désactiver le mode plein écran'
    };
})(inovestor);